import type { SubPortfolioEdit } from '@festina/unitlink-general-types/unitlink'
import { typeUtils, type ValidatedKey } from '@festina-life/core'

import { GenericFormikSelect } from '../../operations/GenericFormikSelect'
import { SubPortfolioFields } from './SubPortfolioFields'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const SubPortfolioEditFields = ({ fieldNamePrefix }: Props) => {
  const validateKey =
    typeUtils.createNestedValidator<SubPortfolioEdit>(fieldNamePrefix)

  return (
    <>
      <GenericFormikSelect
        // @beta translations are omitted because this is a raw command and all other generated fields are untranslated
        label="Edit type"
        name={validateKey('editType')}
        enumType="EditType"
        description="The type of edit."
        component="unitLink"
      />
      <SubPortfolioFields fieldNamePrefix={validateKey('subPortfolio')} />
    </>
  )
}
